import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthStore } from "../auth/auth.store";
import { decodeJwtPayload } from "../auth/jwt";
import { ToastService } from "../services/toast.service";

/**
 * Root redirect: logged-in staff → /dashboard, logged-in member → /wallets, else /login.
 * Phase 53 — adds onboarding gating: authenticated without business → /onboarding?reason=onboarding_incomplete + toast
 */
export const rootRedirectGuard: CanActivateFn = async (): Promise<UrlTree> => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const toast = inject(ToastService);
  const token = authStore.accessToken();

  if (!token || !authStore.isAuthenticated()) {
    return router.createUrlTree(["/login"]);
  }

  try {
    // Phase 53 gating before role decision — prevents flash dashboard when businessIds=[]
    if (authStore.isAuthenticated()) {
      const needs = await authStore.confirmNeedsOnboarding();
      if (needs) {
        toast.show('Antes de continuar es necesario completar el onboarding', 'info', 4000);
        return router.createUrlTree(['/onboarding'], { queryParams: { reason: 'onboarding_incomplete' } });
      }
    }
    const payload = decodeJwtPayload(token);
    const subjectType = payload.subjectType as "user" | "member" | undefined;
    if (subjectType === "member") {
      return router.createUrlTree(["/wallets"]);
    }
    return router.createUrlTree(["/dashboard"]);
  } catch {
    return router.createUrlTree(["/login"]);
  }
};